<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="py-0">
        <v-row justify="end" dense>
          <v-col cols="auto" class="py-0">
            <inertia-link :href="route('customer.create')">
              <v-btn color="primary">
                Kunden anlegen
              </v-btn>
            </inertia-link>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="suche"
          append-icon="mdi-table-search"
          label="Suche"
          single-line
          hide-details
        />
      </v-col>

      <v-col cols="12">
        <v-data-table
          :items="companyList"
          :headers="headers"
          :search="suche"
          :options.sync="options"
          :footer-props="{
            itemsPerPageOptions: [-1, 50, 100],
          }"
          @click:row="navigateToCustomer"
        >
          <template #[`item.name`]="{ item }">
            <inertia-link
              :href="route('customer.show.uebersicht', { customer: item.id })"
            >
              {{ item.name }}
            </inertia-link>
          </template>
          <template #[`item.turnover`]="{ item }">
            {{
              new Intl.NumberFormat("de-DE", {
                style: "currency",
                currency: "EUR",
              }).format(item.turnover)
            }}
          </template>
          <template #[`item.contactPerson`]="{ item }">
            <span v-if="item.contactPerson">
              {{ item.contactPerson.form_of_address == "Mr." ? "Herr" : "Frau" }} {{ item.contactPerson.first_name }} {{ item.contactPerson.last_name }}
            </span>
          </template>
          <template #[`item.monthly_turnover`]="{ item }">
            {{
              new Intl.NumberFormat("de-DE", {
                style: "currency",
                currency: "EUR",
              }).format(item.monthly_turnover)
            }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Layout from '@/Layouts/Default'

export default {
   metaInfo () {
      // don't know your return object structure,
      // maybe you should check whole this.getViewPage
      return {
         title: this.title ? this.title : 'Kundenübersicht',
      }
   },
   layout: (h, page) => h(Layout, [page]),
   props: {
      companyList: {
         type: Array,
         required: true,
      },
   },
   remember: {
      data: ['options', 'suche'],
      key: 'Customer/Index',
   },
   data: (vm) => ({
      headers: [
         { text: 'KDNR.', value: 'customer_number' },
         { text: 'Firma', value: 'name' },
         { text: 'Vertriebsteam', value: 'team' },
         { text: 'VB.', value: 'vb.name' },
         { text: 'ASP.', value: 'contactPerson' },
         { text: 'Umsatz ges.', value: 'turnover' },
         { text: 'Umsatz mtl.', value: 'monthly_turnover' },
         { text: 'offene Preisinfo', value: 'openOfferCount' },
         { text: 'offene Angebote', value: 'offerProcessCount' },
         { text: 'Verträge', value: 'contractCount' },
      ],
      suche: '',
      options: {
         page: 1,
         itemsPerPage: 50,
         sortBy: ['name'],
         sortDesc: [true],
         multiSort: false,
      },
   }),

   methods: {
      create () {
         this.$inertia.visit(this.route('organizations.create'))
      },
      edit (_organisation) {
         this.$inertia.visit(this.route('organizations.edit', _organisation))
      },
      navigateToCustomer (_organisation) {
         this.$inertia.visit(this.route('customer.show', _organisation))
      },
   },
}
</script>
